import React from 'react';
import { useAppContext } from '@/contexts/AppContext';
import changeRoleIcon from '@/assets/images/change-user-xxl.png';
import AppAtag from '@/components/AppAtag';
import { APP_ROLE, getSelectedRole, saveSelectedRole } from '@/services/roleService';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const ChangeRoleComponent = () => {
  const { auth } = useAppContext();
  const { t } = useTranslation();

  const hasGuideSupport = React.useMemo(() => {
    return auth?.originRoleClaims?.includes(APP_ROLE.GuideSupport);
  }, [auth]);

  const currentRoles = React.useMemo(() => {
    let selectedRole = getSelectedRole();
    if (selectedRole === APP_ROLE.GuideSupport) {
      return APP_ROLE.GuideSupport;
    }
    return auth?.roleClaims?.join(',');
  }, [auth]);

  const onChangeRole = () => {
    if (auth) {
      const { roleClaims } = auth;
      if (roleClaims.length) {
        if (currentRoles === APP_ROLE.GuideSupport) {
          saveSelectedRole(undefined);

          window.setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          saveSelectedRole(APP_ROLE.GuideSupport);
          window.setTimeout(() => {
            window.location.reload();
          }, 100);
        }
      }
    }
  };

  if (hasGuideSupport) {
    return (
      <div className="notification hide-on-mobile">
        <AppAtag className="head-example">
          <Tooltip title={t(currentRoles || '')}>
            <img
              src={changeRoleIcon}
              style={{ width: 30, height: 30 }}
              alt="change role"
              onClick={() => {
                onChangeRole();
              }}
            />
          </Tooltip>
        </AppAtag>
      </div>
    );
  }
  return null;
};

export default ChangeRoleComponent;
